
import { defineComponent, ref, onBeforeMount } from 'vue';
import { useRouter } from 'vue-router';
import { TLayout } from '@tencent/web-vbui';
import { spin } from '@tencent/web-vbui/src/components/t-spin/spin';
import { navigator } from '@tencent/vb-app-bridge';
import { i18n } from '@tencent/vb-web-base';
import { to } from '@tencent/vb-web-base-core';
import { baseMixins } from '@common/mixins/baseMixins';
import { getUserStatus } from '@common/core/network/TypeAPI';
import { GetLoanConfigList } from '../../core/network/NodeAPI';
import { IInviteCodeEntranceConfItem } from '../../core/interface/IModel';
import { accountCheck, RESULTCODE } from '@tencent/vb-web-base/dist/accountTips';

export default defineComponent({
  name: 'Entrance',
  components: {
    TLayout,
  },
  setup() {
    const { setTitle, getLanguage, showModalError, isEng } = baseMixins();
    const entranceList = ref<IInviteCodeEntranceConfItem[]>([]);
    const storageLink = ref<{ [key: string]: string }>({});
    const uidStr = ref('');
    const accNo = ref('');
    // 多语言设置标题
    const { getT } = i18n;
    const $t = getT();
    setTitle($t('贷款'));
    const lang = getLanguage();
    const router = useRouter();

    const formatParam = (p: string, lang: string) => {
      try {
        return JSON.parse(p)[0][lang];
      } catch (error) {
        return p;
      }
    };

    const getUserUid = async () => {
      const [data, err] = await to(getUserStatus());
      if (err) {
        showModalError(err.message, err.code);
        return;
      }
      uidStr.value = data.uidStr;
      accNo.value = data.acctNo;
    };

    // 获取入口配置
    const getConfigInfo = async () => {
      const [data, err] = await to(GetLoanConfigList<{ content: IInviteCodeEntranceConfItem[] }>('mgm_act_list'));
      if (err) {
        showModalError(err.message, err.code);
        return;
      }
      try {
        const storage = localStorage.getItem(`storageLink_${accNo.value}`);
        if (storage) {
          storageLink.value = JSON.parse(storage);
        }
      } catch (err) {}
      if (data?.content?.length) {
        entranceList.value = data.content
          .map((item) => ({
            ...item,
            image: formatParam(item.image, lang),
            showNewLabel: item.isNew === '1',
          }))
          .filter((item) => {
            if (item.isWhite === '2') {
              try {
                const itemUids = JSON.parse(item.uids) as { key: string }[];
                return itemUids.find((uid) => uid.key === uidStr.value);
              } catch (error) {
                return false;
              }
            }
            return true;
          })
          .filter((item) => Number(item.isOffLine) !== 2)
          .sort((a: IInviteCodeEntranceConfItem, b: IInviteCodeEntranceConfItem) => {
            if (Number(a.order) !== Number(b.order)) {
              return Number(a.order) - Number(b.order);
            }
            return Number(b.updateTime) - Number(a.updateTime);
          });
      }
    };

    const jumpTo = (linkInfo: IInviteCodeEntranceConfItem) => {
      // 默认是weex类型
      const { link, type = 'html', showNewLabel } = linkInfo;

      if (!link) {
        return;
      }
      if (showNewLabel) {
        storageLink.value[link] = '1';
        localStorage.setItem(`storageLink_${accNo.value}`, JSON.stringify(storageLink.value));
      }
      // 入金前强校验开户
      switch (type) {
        case 'app': {
          navigator.push(
            {
              path: link,
            },
            {
              target: 'native',
            },
          );
          break;
        }
        case 'html': {
          // 跳转的web地址白名单只支持vb域名，需要添加其他域名支持跳转，需要app发版本
          navigator.pushPure(link);
          break;
        }
        case 'weex': {
          navigator.push(link);
          break;
        }
        default:
          break;
      }
    };

    const goRecordListPage = async () => {
      const res = await accountCheck({
        needAutoLogin: true,
        loginReload: true,
        needActivateModal: true,
        needOpenModal: true,
      });
      if (res.code === RESULTCODE.LOGINRELOAD) {
        return;
      }
      if (res.code !== RESULTCODE.SUCCESS) {
        return;
      }
      router.push('/inviteCodeRecordList');
    };
    onBeforeMount(async () => {
      spin.show();
      await getUserUid();
      await getConfigInfo();
      spin.hide();
    });
    return {
      storageLink,
      isEng,
      entranceList,
      lang,
      jumpTo,
      goRecordListPage,
    };
  },
});
